import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Grid } from "@mui/material";
import isEqual from "react-fast-compare";
import Table from "../../common/tableWithBackEndPagination";
import ConfirmDialoag from "../../common/ConfirmDialoag";
import Loader from "../../../Layout/Loader";
import Button from "../../common/Button";
import TextField from "../../common/TextField";
import AddMakeModal from "./addMake";
import { PaginationConfig } from "../../../Helpers";

let source;

const formDefaultState = {
  makeName: "",
};

const makeDataFormat = (data, id, parentId) => ({
  id: id || 0,
  makeName: data?.makeName ? data.makeName.trim() : "",
  parentId: parentId || 0,
  archive: data?.archive || false,
  archiveTime: data?.archiveTime || null,
});

class MakesList extends Component {
  constructor() {
    super();
    this.state = {
      ...PaginationConfig,
      selectedMake: "",
      addOption: false,
      editOption: false,
      defaultMakeList: false,
      onDeleteConfirmation: false,
      tableData: [],
      pagData: "",
      form: { ...formDefaultState },
      isVisableMakeBtn: false,
      isVisableMakeBtnforEdit: false,
      loading: false,
    };
  }

  componentDidMount() {
    this.getMakesData();
  }

  componentWillUnmount() {
    if (source) {
      source.cancel();
    }
  }

  getMakesData = () => {
    const { page, pageSize, itemSearch } = this.state;
    if (!this.props.logInUser?.id) return;

    this.setState({ loading: true });
    const apiCall = `/api/makes/get?page=${page}&limit=${pageSize}&make=${itemSearch || ""}`;
    source = axios.CancelToken.source();

    axios
      .get(apiCall, { cancelToken: source.token })
      .then((response) => {
        const res = response.data;
        if (res.status === "success") {
          const udata = res.data?.data || [];
          this.setState({
            tableData: udata,
            defaultMakeList: true,
            pagData: res.data,
            loading: false,
          });
        } else if (res?.statusCode === "440") {
          window.location.replace("/login");
        } else if (res.statusCode) {
          const err = res?.message?.split(":");
          if (err?.[1]) {
            toast.error(this.props.translate(err[1].replace(")", "")));
          }
          this.setState({ loading: false, defaultMakeList: true });
        }
      })
      .catch(() => {
        this.setState({ loading: false, defaultMakeList: true });
      });
  };

  removeMake = (selected) => {
    this.setState({
      onDeleteConfirmation: true,
      selectedMake: selected?.[0] || selected,
    });
  };

  deleteItem = () => {
    const { selectedMake } = this.state;
    if (!selectedMake?.id) return;

    fetch(`/api/makes/${selectedMake.id}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((res) => {
        if (res.status === "success") {
          toast.success(this.props.translate("deletedSuccessfully"));
          this.getMakesData();
        } else if (res?.statusCode === "440") {
          window.location.replace("/login");
        } else if (res.statusCode) {
          const err = res?.message?.split(":");
          if (err?.[1]) {
            toast.error(this.props.translate(err[1].replace(")", "")));
          }
        }
      })
      .catch(() => {
        toast.error(this.props.translate("somethingwentWrong"));
      });

    this.setState({
      form: { ...formDefaultState },
      onDeleteConfirmation: false,
      addOption: false,
      defaultMakeList: true,
    });
  };

  onCancel = () => {
    this.setState({ onDeleteConfirmation: false });
  };

  handleChangeRowsPerPage = (value) => {
    this.setState({ pageSize: value }, () => this.getMakesData());
  };

  handleChangePage = (value) => {
    this.setState({ page: value }, () => this.getMakesData());
  };

  SearchItem = (searchValue) => {
    if (source) {
      source.cancel();
    }
    this.setState({ page: 1, itemSearch: searchValue }, () => this.getMakesData());
  };

  checkFloteNumber(n) {
    return Number(n) === n && n % 1 !== 0;
  }

  setPagination = (user) => {
    if (this.state.pagData) {
      const nUser = { ...user };
      const lastPage = nUser.total / this.state.pageSize;
      const IsFloate = this.checkFloteNumber(lastPage);
      delete nUser.data;
      nUser.pageSize = this.state.pageSize;
      nUser.lastPage = IsFloate ? parseInt(lastPage + 1) : lastPage;
      return nUser;
    }
    return {};
  };

  addMake = () => {
    this.setState({
      selectedMake: "",
      editOption: false,
      addOption: true,
      form: { ...formDefaultState },
      defaultMakeList: false,
    });
  };

  handleChange = (name) => (event) => {
    const value = event?.target?.value ?? "";
    this.setState(
      (preState) => ({
        form: {
          ...preState.form,
          [name]: value,
        },
      }),
      () => this.checkRequiredFields(),
    );
  };

  checkRequiredFields() {
    const { makeName } = this.state.form;
    const changed = !isEqual(this.state.form, this.state.selectedMake);
    if (makeName?.trim()) {
      this.setState({ isVisableMakeBtn: true });
      if (changed) {
        this.setState({ isVisableMakeBtnforEdit: true });
      }
    } else {
      this.setState({
        isVisableMakeBtn: false,
        isVisableMakeBtnforEdit: false,
      });
    }
  }

  ag_submit = () => {
    const parentId = this.props.logInUser?.id || 0;
    const obj = makeDataFormat(this.state.form, 0, parentId);

    fetch("/api/makes", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(obj),
    })
      .then((response) => response.json())
      .then((res) => {
        if (res.status === "success") {
          toast.success(this.props.translate("createdSuccessfully"));
        } else if (res?.statusCode === "440") {
          window.location.replace("/login");
        } else if (res.statusCode) {
          const err = res?.message?.split(":");
          if (err?.[1]) {
            toast.error(this.props.translate(err[1].replace(")", "")));
          }
        }
      })
      .catch(() => {
        toast.error(this.props.translate("somethingwentWrong"));
      });

    this.setState(
      {
        addOption: false,
        form: { ...formDefaultState },
        defaultMakeList: true,
      },
      () => this.getMakesData(),
    );
  };

  modalControle = () => {
    this.setState({
      addOption: false,
      editOption: false,
      selectedMake: "",
      defaultMakeList: true,
      isVisableMakeBtn: false,
      isVisableMakeBtnforEdit: false,
      form: { ...formDefaultState },
    });
  };

  makeSelection = (item) => {
    if (item) {
      this.setState({
        editOption: true,
        selectedMake: item,
        defaultMakeList: false,
        form: { makeName: item.makeName || "" },
      });
    }
  };

  onEdit = (selected) => {
    if (selected?.[0]) {
      this.makeSelection(selected[0]);
    }
  };

  ug_submit = () => {
    const itemId = this.state.selectedMake.id;
    const parentId = this.props.logInUser?.id || 0;
    const obj = makeDataFormat(this.state.form, itemId, parentId);

    fetch(`/api/makes/${itemId}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(obj),
    })
      .then((response) => response.json())
      .then((res) => {
        if (res.status === "success") {
          toast.success(this.props.translate("updatedSuccessfully"));
        } else if (res?.statusCode === "440") {
          window.location.replace("/login");
        } else if (res.statusCode) {
          const err = res?.message?.split(":");
          if (err?.[1]) {
            toast.error(this.props.translate(err[1].replace(")", "")));
          }
        }
      })
      .catch(() => {
        toast.error(this.props.translate("somethingwentWrong"));
      });

    this.setState(
      {
        addOption: false,
        editOption: false,
        form: { ...formDefaultState },
        defaultMakeList: true,
      },
      () => this.getMakesData(),
    );
  };

  render() {
    const rowDefinition = [
      {
        id: "makeName",
        numeric: false,
        disablePadding: false,
        label: this.props.translate("makeName"),
      },
    ];

    return (
      <div style={{ position: "relative" }}>
        {this.state.addOption && (
          <AddMakeModal
            title={this.props.translate("addMake")}
            formSubmit={this.ag_submit}
            handleChange={this.handleChange}
            form={this.state.form}
            modalControle={this.modalControle}
            buttonText={this.props.translate("sharedCreate")}
            isVisableCreateBtn={this.state.isVisableMakeBtn}
            translate={this.props.translate}
          />
        )}

        {this.state.editOption && (
          <AddMakeModal
            title={this.props.translate("editMake")}
            formSubmit={this.ug_submit}
            handleChange={this.handleChange}
            form={this.state.form}
            modalControle={this.modalControle}
            buttonText={this.props.translate("update")}
            isVisableCreateBtn={this.state.isVisableMakeBtnforEdit}
            translate={this.props.translate}
          />
        )}

        {this.state.defaultMakeList ? (
          <>
            <Grid container className="breadcrumb-row">
              <Grid item xs={12} sm={4}>
                <h3 style={{ margin: 0 }}>{this.props.translate("vehicleMakes")}</h3>
              </Grid>
              <Grid item xs={12} sm={8} style={{ justifyContent: "flex-end" }}>
                <div style={{ width: "25%", marginRight: 20 }}>
                  <TextField
                    fullWidth
                    label={this.props.translate("search")}
                    onChange={(e) => this.SearchItem(e.target.value)}
                  />
                </div>
                <Button
                  aria-label="Create"
                  size="small"
                  color="inherit"
                  onClick={this.addMake}
                  id="createButton"
                >
                  {this.props.translate("create")}
                </Button>
              </Grid>
            </Grid>
            {this.state.loading ? (
              <Loader />
            ) : (
              <Table
                rows={this.state.tableData || []}
                pagination={this.setPagination(this.state.pagData)}
                handleChangeRowsPerPage={this.handleChangeRowsPerPage}
                handleChangePage={this.handleChangePage}
                SearchItem={this.SearchItem}
                onDelete={this.removeMake}
                onEdit={this.onEdit}
                themecolors={this.props.themecolors}
                isRowIcons={false}
                isCursoPointer
                filterDropdown
                setSerialNo
                rowDefinition={rowDefinition}
                hasAccessOfDelete={true}
                isEditable={true}
                onClick={this.makeSelection}
              />
            )}
          </>
        ) : (
          !this.state.addOption && !this.state.editOption && <Loader />
        )}

        {this.state.onDeleteConfirmation && (
          <ConfirmDialoag
            onCancel={this.onCancel}
            onOk={this.deleteItem}
            title={this.props.translate("areYouWantToDelete")}
            children={this.state.selectedMake?.makeName}
          />
        )}
      </div>
    );
  }
}

const mapState = (state) => ({
  logInUser: state.logInUsers,
  themecolors: state.themecolors,
});

export const VehicleMakesList = connect(mapState)(MakesList);
